import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Cobrás de oído',
    costo: 'Perdés plata en cada trabajo sin darte cuenta'
  }, {
    sin: 'Sin sistema de soldadura',
    costo: 'Años trabajando con vicios que limitan tu calidad'
  }, {
    sin: 'Sin planos profesionales',
    costo: 'Rechazás trabajos que otros herreros se llevan'
  }, {
    sin: 'Sin técnica de ventas',
    costo: 'Clientes que regatean y trabajos que no cerrás'
  }, {
    sin: 'Sin saber costear',
    costo: 'Fin de mes sin entender por qué no te sobra nada'
  }, {
    sin: 'Sin los planos de GYM y Trailers',
    costo: 'Siempre "para después" — y nunca arrancás'
  }];
  return <section className="py-20 bg-zinc-900 text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-22">
          <div className="min-w-[600px]" data-id="element-23">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-24">
              <div className="font-bold text-amber-300 uppercase text-sm tracking-wider" data-id="element-25">
                ❌ Sin el Megapack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-26">
                💸 Lo que realmente perdés
              </div>
            </div>

            <div className="space-y-2" data-id="element-27">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-black/60 rounded-xl p-4 items-center border border-amber-900/30" data-id="element-28">
                  <div className="text-zinc-100 font-medium" data-id="element-29">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-30">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-amber-400 mt-4 md:hidden" data-id="element-31">
            ← Deslizá para ver la tabla completa →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-amber-600 to-amber-900 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-32">
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-33">
            🔨🇦🇷 "La próxima vez que llegue un trabajo difícil, vas a saber
            exactamente cómo hacerlo — y cuánto cobrar."
          </p>
        </motion.div>
      </div>
    </section>;
}